export const productTypeSelect = {
	label: "Tipo de producto",
	placeholder: "Selecciona tipo",
	loading: "Cargando...",
};
